<template>
  <div class="layout-wrapper">
    <!-- Sidebar -->
    <div class="sidebar">
      <Menu />
    </div>

    <!-- Main -->
    <div
      class="main"
      style="padding: 0 !important"
    >
      <!-- Top Nav -->
      <div
        ref="navBar"
        class="nav"
      >
        <!-- Tabs Section -->
        <div class="tabs-section">
          <!-- Left Arrow -->
          <button
            class="scroll-btn"
            :disabled="!showLeftArrow"
            @click="scrollTabs('left')"
          >
            <v-icon size="20">
              mdi-arrow-right-bold-circle-outline
            </v-icon>
          </button>

          <!-- Tabs viewport (no native scroll) -->
          <div
            ref="tabsViewport"
            class="tabs-viewport"
          >
            <div
              ref="tabsTrack"
              class="tabs-track"
              :style="{ transform: `translateX(${scrollPos}px)` }"
            >
              <div
                v-for="(tab, index) in $store.state.tabManagement.tabs"
                :key="tab.form.id"
                class="tab-item"
                :class="{
                  active: index === $store.state.tabManagement.activeTab,
                }"
                @click="click(index)"
              >
                <span class="tab-label">
                  {{ $t(tab.form, tab.model) }}
                </span>

                <!-- Close tab -->
                <button
                  class="tab-close"
                  @click.stop="deleteTab(index)"
                >
                  <v-icon size="16">
                    mdi-close
                  </v-icon>
                </button>
              </div>
            </div>
          </div>

          <!-- Right Arrow -->
          <button
            class="scroll-btn"
            :disabled="!showRightArrow"
            @click="scrollTabs('right')"
          >
            <v-icon size="20">
              mdi-arrow-left-bold-circle-outline
            </v-icon>
          </button>
        </div>

        <!-- Right Icons -->
        <div class="icons BG1">
          <!-- User menu -->
          <v-menu offset-y>
            <template #activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                rounded
                small
                depressed
                class="mx-2"
                v-on="on"
              >
                <span>{{ getUsername }}{{ getUserRole }}</span>
                <v-icon class="mr-2">
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-for="role in roleList"
                :key="role.PostID"
                :class="{ selected: role.PostID == $store.state.role }"
                @click="showDrop(role.PostID)"
              >
                <v-list-item-title>{{ role.Label }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- Actions menu -->
          <v-menu offset-y>
            <template #activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                icon
                class="mx-1"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <!-- <v-list-item @click="showNotifications">
                <v-list-item-icon>
                  <v-icon>mdi-bell-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>اعلانات</v-list-item-title>
              </v-list-item> -->

              <v-list-item @click="ChangePassword">
                <v-list-item-icon>
                  <v-icon>mdi-lock-reset</v-icon>
                </v-list-item-icon>
                <v-list-item-title>تغییر رمز عبور</v-list-item-title>
              </v-list-item>

              <!-- <v-list-item @click="changeLanguage">
                <v-list-item-icon>
                  <v-icon>mdi-translate</v-icon>
                </v-list-item-icon>
                <v-list-item-title>تغییر زبان</v-list-item-title>
              </v-list-item> -->

              <v-list-item @click="openSettings">
                <v-list-item-icon>
                  <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>تنظیمات</v-list-item-title>
              </v-list-item>

              <v-divider />

              <v-list-item @click="$oidc.signOut()">
                <v-list-item-icon>
                  <v-icon color="red">
                    mdi-logout-variant
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title class="red--text">
                  خروج
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- Theme toggle -->
          <v-btn
            icon
            class="mx-1"
            @click="toggleTheme"
          >
            <v-icon>
              {{
                $vuetify.theme.dark
                  ? "mdi-white-balance-sunny"
                  : "mdi-weather-night"
              }}
            </v-icon>
          </v-btn>
          <!-- Apps Menu (after actions) -->
          <v-btn
            icon
            class="mx-1"
            @click.stop="toggleMenu = !toggleMenu"
          >
            <v-icon
              class="icon"
              color="var(--abr-p1)"
            >
              mdi-dots-grid
            </v-icon>
          </v-btn>

          <!-- Apps Dropdown -->
          <v-menu
            v-model="toggleMenu"
            absolute
            eager
            offset-y
            transition="slide-x-transition"
          >
            <v-card
              tile
              style="max-width: 40vh; height: 100%; overflow: hidden"
            >
              <div
                v-for="(app, index) in $store.state.root.apps"
                :key="index"
              >
                <v-hover>
                  <template #default="{ hover }">
                    <v-card
                      style="cursor: pointer"
                      :elevation="hover ? 3 : 0"
                      class="d-flex flex-column align-center justify-space-around my-3 pa-2"
                      @click="clickMenu(app)"
                    >
                      <v-icon
                        size="38"
                        color="var(--abr-p1)"
                      >
                        {{ appIcons[app.name] || 'mdi-apps' }}
                      </v-icon>
                      <span style="font-size: 15px">{{ $t(app) }}</span>
                    </v-card>
                  </template>
                </v-hover>
              </div>
            </v-card>
          </v-menu>
        </div>
      </div>

      <!-- Page content -->
      <div class="content">
        <div class="content-wrapper">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/layout/menu";
import jwtDecode from "@/ext/Custom/Def-UI/jwtDecode";
import { invokeFn, instance } from "@/apis";

export default {
  name: "Default",
  components: { Menu },

  data: () => ({
    toggleMenu: false,
    appImages: [],
    roleList: [],
    scrollPos: 0,
    maxScroll: 0,
    showLeftArrow: false,
    showRightArrow: true,
  appIcons: {
    AbrLA: "mdi-account-heart-outline",      // بیمه های زندگی
    AbrPC: "mdi-home-city-outline",          // اموال و مسئولیت
    AbrRE: "mdi-handshake-outline",          // اتکایی
    AbrManager: "mdi-account-tie-outline",   // مدیریت و رهبری
    AbrPH: "mdi-umbrella-outline",           // بیمه گذاران
    AbrDeveloper: "mdi-code-braces",         // توسعه
    AbrAccounting: "mdi-calculator-variant-outline", // مالی و حسابداری
    AbrAgency: "mdi-account-group-outline"   // نمایندگان
  }
  }),

  computed: {
    // Decode username from token
    getUsername() {
      const token = this.$store.state.auth?.user?.access_token;
      const decoded = jwtDecode(token);
      return decoded?.name;
    },

    // Get role label
    getUserRole() {
      const role = this.roleList.find(
        (r) => r.PostID == this.$store.state.role,
      );
      return role ? " - " + role.Label : "";
    },

   mode() {
    return this.$store.getters.tabs[
      this.$store.state.tabManagement.activeTab
    ]?.mode;
  },  activeTabMode() {
    return this.$store.state.tabManagement.tabs.map(
      t => t.model?.mode
    );
  }

  },

  async created() {
    if (window.innerWidth < 1300) this.tabCount = 3;
    this.roleList = await invokeFn("ECore.AccessControl.fnmUser.fnListUserPosts", {});
  },

  mounted() {
    // Calculate tab bounds
    this.updateBounds();
    window.addEventListener("resize", this.updateBounds);
  },

  methods: {
    // Toggle theme
    toggleTheme() {
      const newTheme = !this.$vuetify.theme.dark;
      this.$vuetify.theme.dark = newTheme;
      localStorage.setItem("theme", newTheme ? "dark" : "light");
    },

    // Password page
    ChangePassword() {
      const url = instance().authenticationAuthority;
      window.open(`${url}/Manage/ChangePassword`, "_blank");
    },

    changeLanguage() {
      const current = localStorage.getItem("lang");
      localStorage.setItem("lang", current === "fa" ? "en" : "fa");
      location.reload();
    },

    openSettings() {
      this.$toast.info("Settings coming soon");
    },

    showNotifications() {
      this.$toast.info("Notifications");
    },

    // =========================
    // Tabs logic (carousel)
    // =========================

    updateBounds() {
      this.$nextTick(() => {
        const viewport = this.$refs.tabsViewport;
        const track = this.$refs.tabsTrack;

        if (!viewport || !track) return;

        const vw = viewport.clientWidth;
        const tw = track.scrollWidth;

        this.maxScroll = Math.max(0, tw - vw);

        this.clamp();
      });
    },

    clamp() {
      // Keep scroll inside bounds
      if (this.scrollPos > 0) this.scrollPos = 0;
      if (this.scrollPos < -this.maxScroll) {
        this.scrollPos = -this.maxScroll;
      }

      // Arrow states
      this.showLeftArrow = this.scrollPos < 0;
      this.showRightArrow = Math.abs(this.scrollPos) < this.maxScroll;
    },

    scrollTabs(direction) {
      const step = 180;

      // FIX RTL direction
      const isRTL =
        document.dir === "rtl" ||
        getComputedStyle(document.body).direction === "rtl";

      if (direction === "right") {
        this.scrollPos += isRTL ? step : -step;
      } else {
        this.scrollPos -= isRTL ? step : -step;
      }

      this.clamp();
    },
    // Focus active tab into view
    focusTab(index) {
      this.$nextTick(() => {
        const track = this.$refs.tabsTrack;
        const tab = track?.children?.[index];

        if (tab) {
          tab.scrollIntoView({
            behavior: "smooth",
            inline: "center",
          });
        }
      });
    },

    // Click tab
    async click(index) {
      const { route } = this.$store.getters.tabs[index];

      this.focusTab(index);

      if (this.$route.name === route.name) return;

      await this.$router.push(route);
    },

    // Delete tab
  async deleteTab(index) {
  const isActive = index === this.$store.state.tabManagement.activeTab;

  await this.$store.dispatch("DELETE_TAB", index);

  this.$nextTick(async () => {
    const tabs = this.$store.state.tabManagement.tabs;

    // No tabs left
    if (!tabs.length) {
      await this.$router.push({ name: "AppHome" });
      return;
    }

    // If deleted tab was active → pick new active
    if (isActive) {
      const newIndex =
        index < tabs.length ? index : tabs.length - 1;

      this.$store.commit("SET_ACTIVE_TAB", newIndex);

      const route = this.$store.getters.tabs[newIndex]?.route;

      if (route) {
        await this.$router.push(route);
      }
    } else {
      // keep current active but fix index alignment
      const activeTab = this.$store.getters.getActiveTab;

      this.$store.commit(
        "SET_ACTIVE_TAB",
        tabs.findIndex(t => t.form.id === activeTab.form.id)
      );
    }
  });
},

    // Role switch
    showDrop(postId) {
      window.open(`/?role=${postId}`, "_self");
    },
    clickMenu(app) {
      let routeData = this.$router.resolve({
        name: "AppHome",
        params: { app: app.name },
      });
      console.log('routeData :>> ', routeData);
      window.open(routeData.href + `?role=${this.$store.state.role}`, "_blank");
    },
  },
};
</script>

<style>
.layout-wrapper {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

/* Sidebar */
.sidebar {
  flex-shrink: 0;
  height: 100vh;
}

/* Main */
.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Nav */
.nav {
  height: 42px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px;
  background: var(--abr-bg1);
}

/* Tabs */
.tabs-section {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.tabs-viewport {
  flex: 1;
  overflow: hidden;
  position: relative;
}

/* Track (moves instead of scroll) */
.tabs-track {
  display: flex;
  gap: 4px;
  transition: transform 0.25s ease;
  will-change: transform;
}

/* Tab */
.tab-item {
  display: flex;
  align-items: center;
  font-size: 13px !important; /* force small text */
  font-weight: 500;
  padding: 0 12px;
  height: 32px;
  white-space: nowrap;
  border-radius: 6px;
  cursor: pointer;
  gap: 5px;
}
.tab-label {
  font-size: 12px !important; /* prevent inheritance */
  line-height: 1.2;
}

.tab-item.active {
  background: var(--abr-p2);
}

/* Buttons */
.scroll-btn {
  width: 28px;
  height: 28px;
}
.content {
  flex: 1;
  overflow-y: auto;
  overflow-x: auto;
  min-width: 0;
  padding: auto;
}
.content-wrapper {
  width: 100%;
  min-width: 0;
}
</style>
